import React from 'react';
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import useZibi from "../../../zibi/UseZibi";
import EdgeStatus from "../../EdgeStatus";
import {useLocation, useNavigate} from "react-router-dom";
import {addOrDeleteQueryParams, getQueryValue} from "../../../domain/queryHandler";
import IconBtn from "../../IconBtn";
import {colors} from "../../../maps/colors";
import {api} from "../../../maps/data";
import EdgeEditModal from "../modals/EdgeEditModal";

const WrapperStyled = styled.div`
    position: relative;
    cursor: pointer;
    padding: 13px;
    border-radius: 4px;
    border: 2px solid transparent;
    height: 100%;

    &.selected {
        border-color: #938383;
    }

    .main-title {
        margin-bottom: 7px;
    }
`;

const DataWrapperStyled = styled.div`


`;

const SettingsWrapperStyled = styled.div`
    position: absolute;
    right: 0;
    top: -4px;

    svg {
        width: 15px;
        height: 15px;
    }
`;

export const DataItemStyled = styled.div`
    font-size: 12px;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 3px;
    align-items: baseline;

    .title {
        font-size: 11px;
        color: rgb(21, 21, 21);
        font-weight: 300;
    }

    .data {
        font-weight: 600;
    }
`;

const Edge = ({item}) => {
    const history = useNavigate();
    const location = useLocation();

    const edgeId = getQueryValue(location, 'edge');
    const editEdgeId = getQueryValue(location, 'edgeEdit');

    const changeUrl = (query) => {
        history({
            search: query
        });
    };
     const [sensorStatuses] = useZibi('sensorStatuses');
    const servicesStatuses = sensorStatuses?.[item?._id]?.services;

    const restartEdge = async () => {
        await api({
            type: 'restartEdge',
            data: {
                edgeId: item._id,
                siteId: item.siteId
            }
        });
    };

    const data = [
        {
            title: "Id", data: item._id
        },
        {
            title: "EdgeIp", data: item.edgeIp
        },
        {
            title: "Internal IP", data: item.internalEdgeIp
        },
        {
            title: "Udp address", data: item.udpAddr
        }
    ];

    const selected = edgeId === item?._id;
    const opedEdgeSettings = editEdgeId === item?._id;

    return (
        <Paper elevation={selected ? 8 : 3}>
            <WrapperStyled
                className={selected ? "selected" : ""}
                onClick={() => {
                    if (selected) {
                        const urlToPush = addOrDeleteQueryParams(location, [{edge: null}]);
                        changeUrl(urlToPush);
                    } else {
                        const urlToPush = addOrDeleteQueryParams(location, [{edge: item._id}]);
                        changeUrl(urlToPush);
                    }
                }}>
                <SettingsWrapperStyled>
                    <IconBtn customtheme="small-gray" size="small" onClick={(e) => {
                        e.stopPropagation();
                        const urlToPush = addOrDeleteQueryParams(location, [{edgeEdit: item._id}]);
                        changeUrl(urlToPush);
                    }}>edit</IconBtn>
                    <IconBtn
                        onClick={(e) => {
                            e.stopPropagation();
                            restartEdge();
                        }}
                        customtheme="small-gray" size="small" style={{marginLeft: 5, color: colors.TEAL}}>
                        restartAltIcon
                    </IconBtn>

                </SettingsWrapperStyled>

                <div className="main-title">
                    {item.floorName} ({item.number})
                </div>
                <DataWrapperStyled>
                    {data.map(d => {
                        return (
                            <DataItemStyled
                                key={d.title}
                            >
                                <div className="title">{d.title}:</div>
                                <div className="data">{d.data}</div>
                            </DataItemStyled>
                        );
                    })}
                </DataWrapperStyled>
                {servicesStatuses && (
                    <EdgeStatus
                        services={servicesStatuses}
                    />
                )}
            </WrapperStyled>
            {opedEdgeSettings && (<EdgeEditModal/>)}
        </Paper>
    );
};

export default Edge;